import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpOther from './_PopUpOther';
import DataConfig from './../_config.json';
import { OnGetJsoni } from '../_getjson';
import Alert from 'react-s-alert';
import './stylemain.css'
const jobTypes = ['เปิด', 'ปิด'];
export default class _tab_3 extends React.Component {
    state = {
        tableData_w: [],
        defaultlibrary: "",
        rowChk_wtb: "",
        rowintable: "200",
        colClick: "",
        getstartedpendleton: "",
        unitsdefaultreceiving: "",
        defaularchives: "",
        defaulpayposition: "",
        unitdefaulpay: "",
        colChk: "",
        wherehosesearch: "",
        actionkey: false,
    }
    _alertPopup = (type, text) => {
        switch (type) {
            case 'Warning': Alert.warning(text, { position: 'bottom-right', effect: 'slide', onShow: function () { }, beep: false, timeout: 2000, offset: 0 }); break;
            case 'Info': Alert.info(text, { position: 'bottom-right', effect: 'slide', onShow: function () { }, beep: false, timeout: 2000, offset: 0 }); break;
            case 'Error': Alert.error(text, { position: 'bottom-right', effect: 'slide', onShow: function () { }, beep: false, timeout: 2000, offset: 0 }); break;
            case 'Success': Alert.success(text, { position: 'bottom-right', effect: 'slide', onShow: function () { }, beep: false, timeout: 2000, offset: 0 }); break;
            default: Alert.closeAll(); break;
        }
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                C0: i + 1,
                C1: "",
                C1_insert: '',
                C2: "",
                C2_insert: "",
                C3: "",
                C3_insert: "",
                C4: "",
            }
        }
        this.setState({ tableData_w: data });
    }
    componentDidMount() {
        this.setRow(this.state.rowintable);
    }

    //**************************************************************************popup**************************************************************************************/
    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
        this.setState({ actionkey: true });
        // console.log(data); 
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {
            case "defaultlibrary":
                // console.log(data);
                this.setState({ defaultlibrary: this._spritData(data)[0] });
                this.refs.defaultlibrary.value = this._spritData(data)[1];
                break;
            case "startuppayroll":
                this.setState({ startuppayroll: this._spritData(data)[0] });
                this.refs.startuppayroll.value = this._spritData(data)[1];
                break;

            case "getstartedpendleton":
                this.setState({ getstartedpendleton: this._spritData(data)[0] });
                this.refs.getstartedpendleton.value = this._spritData(data)[1];
                break;

            case "unitsdefaultreceiving":
                this.setState({ unitsdefaultreceiving: this._spritData(data)[0] });
                this.refs.unitsdefaultreceiving.value = this._spritData(data)[1];
                break;
            case "defaularchives":
                this.setState({ defaularchives: this._spritData(data)[0] });
                this.refs.defaularchives.value = this._spritData(data)[1];
                break;
            case "defaulpayposition":
                this.setState({ defaulpayposition: this._spritData(data)[0] });
                this.refs.defaulpayposition.value = this._spritData(data)[1];
                break;
            case "unitdefaulpay":
                this.setState({ unitdefaulpay: this._spritData(data)[0] });
                this.refs.unitdefaulpay.value = this._spritData(data)[1];
                break;
            case "warehouse":
                if (this.state.colChk === "1" && this.state.rowChk_wtb === "1") {
                    this.setState({
                        defaultlibrary: this._spritData(data)[0]
                    });
                    this.refs.defaultlibrary.value = this._spritData(data)[1];

                    this.setState({
                        defaularchives: this._spritData(data)[0]
                    });
                    this.refs.defaularchives.value = this._spritData(data)[1];
                }
                let unitStockintablearrData = this.state.tableData_w;
                var j = this.state.rowintable;
                for (var i = this.state.tableData_w.length - 1; i >= 0; i--) { // หาจากล่างขึ้นบน
                    if (!this.state.tableData_w[i].C1) {
                        j = i;
                    }
                } //หา แถวที่ว่างบนสุดใน products Table
                unitStockintablearrData[j].C1 = this._spritData(data)[1];
                unitStockintablearrData[j].C1_insert = this._spritData(data)[0];
                this.setState({ C1State: this._spritData(data)[0] });
                unitStockintablearrData[j].btnunit = 2;
                this.setState({ tableData_w: unitStockintablearrData });
                break;
            case "location":
                console.log(this.state.colChk);

                if (this.state.colChk === "3" && this.state.rowChk_wtb === "1") {
                    this.setState({ getstartedpendleton: this._spritData(data)[0] });
                    this.refs.getstartedpendleton.value = this._spritData(data)[1];
                    this.setState({ defaulpayposition: this._spritData(data)[0] });
                    this.refs.defaulpayposition.value = this._spritData(data)[1];
                }
                let locationarrData = this.state.tableData_w;
                locationarrData[this.state.rowChk_wtb - 1].C2 = this._spritData(data)[1];
                locationarrData[this.state.rowChk_wtb - 1].C2_insert = this._spritData(data)[0];
                locationarrData[this.state.rowChk_wtb - 1].btnlocal = 2;
                this.setState({ tableData_w: locationarrData });
                break;
            case "unitStock":
                if (this.state.colChk === "5" && this.state.rowChk_wtb === "1") {

                    this.setState({ unitsdefaultreceiving: this._spritData(data)[0] });
                    this.refs.unitsdefaultreceiving.value = this._spritData(data)[1];

                    this.setState({ unitdefaulpay: this._spritData(data)[0] });
                    this.refs.unitdefaulpay.value = this._spritData(data)[1];

                    console.log(this.state.rowChk_wtb);
                }
                let unitStockarrData = this.state.tableData_w;
                unitStockarrData[this.state.rowChk_wtb - 1].C3 = this._spritData(data)[1];
                unitStockarrData[this.state.rowChk_wtb - 1].C3_insert = this._spritData(data)[0];
                unitStockarrData[this.state.rowChk_wtb - 1].btnunit = 2;
                this.setState({ tableData_w: unitStockarrData });
                break;
            default: break;
        }
        this.setState({ showPopupOT: !this.state.showPopupOT });
        setTimeout(() => {
            this.props.Getdata("datawarehouse", this.state);
        }, 80);
    }
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
        this.setState({ actionkey: false });
    }
    /*----------------------------------------------------------------------------------------------------------------------------*/
    switch_PopUpItem = () => {
        this.setState({ switchPopUpItem: !this.state.switchPopUpItem });
    }
    Switch_PopupArcode = (e) => {
        this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    }


    _spritData(data) {
        var str = data.split("|");
        return str;
    }
    _cellButtonbtnware = (col, row, enumObject, rowIndex) => {
        let btn = this.state.tableData_w[rowIndex].btnware;
        let btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.SetPopup.bind(null, "warehouse")}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    _cellButtonbtnlocal = (col, row, enumObject, rowIndex) => {
        let btn = this.state.tableData_w[rowIndex].btnlocal;
        let btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.SetPopup.bind(null, "location")}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    _cellButtonbtnunit = (col, row, enumObject, rowIndex) => {
        let btn = this.state.tableData_w[rowIndex].btnunit;
        let btnShow = "";
        switch (btn) {
            case 1: btnShow = <i class="fas fa-sort-down icon_down" onClick={this.SetPopup.bind(null, "unitStock")}></i>; break;
            default: btnShow = <i class=""></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    onRowClick = (row, col) => {
        this.setState({
            rowChk_wtb: row['C0']
        });
        setTimeout(() => {
            var dataArray = this.state.tableData_w;
            let tableRow = dataArray.length;
            try {
                let i;
                for (i = 0; i <= tableRow; i++) {
                    if (dataArray[i].btnware === 1) {
                        dataArray[i].btnware = 2;
                    } else if (dataArray[i].btnlocal === 1) {
                        dataArray[i].btnlocal = 2;
                    } else if (dataArray[i].btnunit === 1) {
                        dataArray[i].btnunit = 2;
                    }
                }
            } catch (error) { }
            if (col === 1) {
                if (this.state.rowChk_wtb === "1") {
                    this.setState({
                        colChk: col
                    });
                }
                dataArray[this.state.rowChk_wtb - 1].btnware = 1;
            } else if (col === 3) {
                if (this.state.rowChk_wtb === "1") {
                    this.setState({
                        colChk: col
                    });
                }
                if (dataArray[this.state.rowChk_wtb - 1].C1 === "") {
                    dataArray[this.state.rowChk_wtb - 1].C4 = "";
                } else {
                    dataArray[this.state.rowChk_wtb - 1].C4 = "เปิด";
                }
                dataArray[this.state.rowChk_wtb - 1].btnlocal = 1;
            } else if (col === 5) {
                if (dataArray[this.state.rowChk_wtb - 1].C1 === "") {
                    dataArray[this.state.rowChk_wtb - 1].C4 = "";
                } else {
                    dataArray[this.state.rowChk_wtb - 1].C4 = "เปิด";
                }
                if (this.state.rowChk_wtb === "1") {
                    this.setState({
                        colChk: col
                    });
                }
                dataArray[this.state.rowChk_wtb - 1].btnunit = 1;
            } else {
                try {
                    dataArray[this.state.rowChk_wtb - 1].btnware = 2;
                    dataArray[this.state.rowChk_wtb - 1].btnunit = 2;
                    dataArray[this.state.rowChk_wtb - 1].btnlocal = 2;
                } catch (err) {
                    console.log(err);
                }
            }
            this.setState({
                tableData_w: dataArray
            });
        }, 30);
    }
    afterSaveCell = (row, cellName, cellValue) => {
        if (cellValue.length > 0) {
            this._addData(cellValue, row, cellName);
        }
        if (row.C1 === "") {
            var dataArray = this.state.tableData_w;
            dataArray[this.state.rowChk_wtb - 1].C4 = "";
            dataArray[this.state.rowChk_wtb - 1].C3 = "";
            dataArray[this.state.rowChk_wtb - 1].C2 = "";
            this.setState({ tableData_w: dataArray });

            setTimeout(() => {

                this._chkrowData(row, cellName, cellValue);
            }, 80);
        }
        setTimeout(() => {
            this.props.Getdata("datawarehouse", this.state);
        }, 200);
    }
    _addData = (ItemCode, row, cellName) => {
        var url
        switch (cellName) {
            case "C1":
                url = "CSWAREHOUSE/Code?code=" + ItemCode;
                let col = this.state.tableData_w;
                OnGetJsoni(url, "load").then(data => {
                    // console.log(data);
                    var j = this.state.rowintable;
                    for (var i = this.state.tableData_w.length - 1; i >= 0; i--) { // หาจากล่างขึ้นบน
                        if (!this.state.tableData_w[i].C1) {
                            j = i;
                        } else if (ItemCode === this.state.tableData_w[i].C1) {
                            j = i;
                        }
                    } //หา แถวที่ว่างบนสุดใน products Table
                    if (data.length > 0) {
                        col[row.C0 - 1].C1 = "";
                        for (var i1 = 0; i1 < data.length; i1++) { //เพิ่มขอมูลทั้งหมด ลง products Table 
                            // this.setState({wherehosesearch:})
                            if (col[j].C0 === 1) {
                                this.setState({
                                    defaultlibrary: data[i1].CODE
                                });
                                this.refs.defaultlibrary.value = data[i1].MYNAMETH;

                                this.setState({
                                    defaularchives: data[i1].CODE
                                });
                                this.refs.defaularchives.value = data[i1].MYNAMETH;
                            }
                            col[j] = {
                                C0: this.state.tableData_w[j].C0,
                                C1: data[i1].MYNAMETH,
                                C1_insert: data[i1].CODE,
                            }
                            j++;
                        }
                    } else {
                        col[row.C0 - 1].C1 = "";
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                    }
                    this.setState({
                        tableData_w: col
                    });
                });
                break;
            case "C2":
                url = "CSLOCATION/ByCode?code=" + ItemCode;
                let col_tab_3_2 = this.state.tableData_w;
                OnGetJsoni(url, "load").then(data => {

                    var j = this.state.rowintable;
                    for (var i = this.state.tableData_w.length - 1; i >= 0; i--) { // หาจากล่างขึ้นบน
                        if (!this.state.tableData_w[i].C2) {
                            j = i;
                        } else if (ItemCode === this.state.tableData_w[i].C2) {
                            j = i;
                        }
                    } //หา แถวที่ว่างบนสุดใน products Table 
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            col_tab_3_2[j].C2 = data[i].MYNAMETH;
                            col_tab_3_2[j].C2_insert = data[i].CODE;
                            if (col_tab_3_2[j].C0 === 1) {
                                this.setState({
                                    getstartedpendleton: data[i].CODE
                                });
                                this.refs.getstartedpendleton.value = data[i].MYNAMETH;

                                this.setState({
                                    defaulpayposition: data[i].CODE
                                });
                                this.refs.defaulpayposition.value = data[i].MYNAMETH;
                            }
                        }
                    } else {
                        col_tab_3_2[row.C0 - 1].C2 = "";
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                    }
                    this.setState({
                        tableData_w: col_tab_3_2
                    });
                });
                break;
            case "C3":
                url = "CSUNIT/ByCode?code=" + ItemCode;
                let col_tab_3_3 = this.state.tableData_w;
                OnGetJsoni(url, "load").then(data => {
                    var j = this.state.rowintable;
                    for (let i = this.state.tableData_w.length - 1; i >= 0; i--) { // หาจากล่างขึ้นบน
                        if (!this.state.tableData_w[i].C3) {
                            j = i;
                            // console.log(1); 
                        }
                        else if (ItemCode === this.state.tableData_w[i].C3) {
                            j = i;
                            //    // console.log(2);
                        }
                    } //หา แถวที่ว่างบนสุดใน products Table  
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            //  console.log(data[i].CODE); 
                            col_tab_3_3[j].C3 = data[i].MYNAMETH + ".";
                            col_tab_3_3[j].C3_insert = data[i].CODE;
                            if (col_tab_3_3[j].C0 === 1) {
                                this.setState({
                                    unitsdefaultreceiving: data[i].CODE
                                });
                                this.refs.unitsdefaultreceiving.value = data[i].MYNAMETH;
                                this.setState({
                                    unitdefaulpay: data[i].CODE
                                });
                                this.refs.unitdefaulpay.value = data[i].MYNAMETH;
                            }
                        }
                    } else {
                        col_tab_3_3[row.C0 - 1].C3 = "";
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                    }
                    this.setState({
                        tableData_w: col_tab_3_3
                    });
                });
                break;
            default: break;
        }
        setTimeout(() => {
            this.props.Getdata("datawarehouse", this.state);
        }, 200);
    }
    handleBlur = (event) => {
        console.log(event.target.value);

        if (event.target.value !== "") {
            this._chkData(event.target.id, event.target.value);
        }
    }
    _chkrowData = (row, cellName, cellValue) => {
        if (cellName === "C1") {

            let data_2 = this.state.tableData_w;

            if (row.C0 === 1) {
                this.refs.defaultlibrary.value = data_2[row.C0].C1;
                this.refs.defaularchives.value = data_2[row.C0].C1;
                this.setState({
                    defaultlibrary: data_2[row.C0].C1_insert
                });
                this.setState({
                    defaularchives: data_2[row.C0].C1_insert
                });

                this.refs.getstartedpendleton.value = data_2[row.C0].C2;
                this.refs.defaulpayposition.value = data_2[row.C0].C2;
                this.setState({
                    getstartedpendleton: data_2[row.C0].C2_insert
                });
                this.setState({
                    defaulpayposition: data_2[row.C0].C2_insert
                });

                this.refs.unitsdefaultreceiving.value = data_2[row.C0].C3;
                this.refs.unitdefaulpay.value = data_2[row.C0].C3;
                this.setState({
                    unitsdefaultreceiving: data_2[row.C0].C3_insert
                });
                this.setState({
                    unitdefaulpay: data_2[row.C0].C3_insert
                });
            }
            for (let index = row.C0; index <= data_2.length; index++) {
                try {
                    if (data_2[index].C1 !== "") {
                        data_2[index - 1].C1 = data_2[index].C1;
                        data_2[index - 1].C1_insert = data_2[index].C1_insert;
                        data_2[index - 1].C2 = data_2[index].C2;
                        data_2[index - 1].C2_insert = data_2[index].C2_insert;
                        data_2[index - 1].C3 = data_2[index].C3;
                        data_2[index - 1].C3_insert = data_2[index].C3_insert;
                        data_2[index - 1].C4 = data_2[index].C4;

                        data_2[index].C1_insert = "";
                        data_2[index].C1 = "";
                        data_2[index].C2_insert = "";
                        data_2[index].C2 = "";
                        data_2[index].C3_insert = "";
                        data_2[index].C3 = "";
                        data_2[index].C4 = "";
                    }
                } catch (error) {
                    console.log("err=>" + error);
                }
            }
            this.setState({
                tableData_w: data_2
            });
        }
    }
    _onClick = (event) => {
        this._setDatatiinput(event);
    }
    _setDatatiinput = (event) => {
        switch (event.target.id) {
            case 'defaultlibrary':
                this.refs.defaultlibrary.value = this.state.defaultlibrary;
                break;
            case 'getstartedpendleton':
                this.refs.getstartedpendleton.value = this.state.getstartedpendleton;
                break;
            case 'unitsdefaultreceiving':
                this.refs.unitsdefaultreceiving.value = this.state.unitsdefaultreceiving;
                break;
            case 'defaularchives':
                this.refs.defaularchives.value = this.state.defaularchives;
                break;
            case 'defaulpayposition':
                this.refs.defaulpayposition.value = this.state.defaulpayposition;
                break;
            case 'unitdefaulpay':
                this.refs.unitdefaulpay.value = this.state.unitdefaulpay;
                break;

            default: break;
        }
    }
    _chkData = (e, v) => {
        switch (e) {
            case 'defaultlibrary':
            case 'defaularchives':
                var url = "CSWAREHOUSE/Code?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if (e === 'defaultlibrary') {
                                this.refs.defaultlibrary.value = data[i].MYNAMETH;
                                this.setState({
                                    defaultlibrary: data[i].CODE
                                });
                            } else {
                                this.refs.defaularchives.value = data[i].MYNAMETH;
                                this.setState({
                                    defaularchives: data[i].CODE
                                });
                            }
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");

                        if (e === 'defaultlibrary') {
                            this.refs.defaultlibrary.value = "";
                            this.refs.defaultlibrary.focus();
                            this.setState({
                                defaultlibrary: ""
                            });

                        } else {
                            this.refs.defaularchives.value = "";
                            this.refs.defaularchives.focus();
                            this.setState({
                                defaularchives: ""
                            });
                        }

                    }
                });
                break;
            case 'getstartedpendleton':
            case 'defaulpayposition':

                var url = "CSLOCATION/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {

                        for (var i = 0; i < data.length; i++) {
                            if (e === 'getstartedpendleton') {
                                this.refs.getstartedpendleton.value = data[i].MYNAMETH;
                                this.setState({
                                    getstartedpendleton: data[i].CODE
                                });
                            } else {
                                this.refs.defaulpayposition.value = data[i].MYNAMETH;
                                this.setState({
                                    defaulpayposition: data[i].CODE
                                });
                            }
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        if (e === 'getstartedpendleton') {
                            this.refs.getstartedpendleton.value = "";
                            this.refs.getstartedpendleton.focus();
                            this.setState({
                                getstartedpendleton: ""
                            });
                        } else {
                            this.refs.defaulpayposition.value = "";
                            this.refs.defaulpayposition.focus();
                            this.setState({
                                defaulpayposition: ""
                            });
                        }
                    }
                });
                break;
            case 'unitsdefaultreceiving':
            case 'unitdefaulpay':
                var url = "CSUNIT/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'load').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if (e === 'unitsdefaultreceiving') {
                                this.refs.unitsdefaultreceiving.value = data[i].MYNAMETH;
                                this.setState({
                                    unitsdefaultreceiving: data[i].CODE
                                });
                            } else {
                                this.refs.unitdefaulpay.value = data[i].MYNAMETH;
                                this.setState({
                                    unitdefaulpay: data[i].CODE
                                });
                            }
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        if (e === 'unitsdefaultreceiving') {
                            this.refs.unitsdefaultreceiving.value = "";
                            this.refs.unitsdefaultreceiving.focus();
                            this.setState({
                                unitsdefaultreceiving: ""
                            });
                        } else {
                            this.refs.unitdefaulpay.value = "";
                            this.refs.unitdefaulpay.focus();
                            this.setState({
                                unitdefaulpay: ""
                            });
                        }
                    }
                });
                break;
        }
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        };
        const options = {
            onRowClick: this.onRowClick
        };
        return (
            <div class={this.props.Inventory.showResults === 2 ? '' : "InventoryHidden"}>
                <br></br>
                {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.group} apikeyData={DataConfig.API_KEY[localStorage.getItem("company")]} jwtData={localStorage.getItem("Token")} /> : null}

                <div class="container-fluid">
                    <BootstrapTable
                        data={this.state.tableData_w}
                        cellEdit={cellEditProp}
                        options={options}
                        height='300'
                        headerStyle={{ borderBottom: '#BFBCBB  1px solid' }}>

                        <TableHeaderColumn row='0' rowSpan='2' dataField='C0' width='40' isKey headerAlign='center' dataAlign='center' ></TableHeaderColumn>

                        <TableHeaderColumn row='0' colSpan='2' headerAlign='center' width='100' className='colbuttomhidden'>คลัง</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C1' dataAlign="center" editable  ></TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='btnware' dataAlign="center" editable={false} width="30" dataFormat={this._cellButtonbtnware.bind(this)} columnClassName='c_btn'>
                        </TableHeaderColumn>

                        <TableHeaderColumn row='0' colSpan='2' headerAlign='center' width='100' className='colbuttomhidden' >ตำแหน่งเก็บ</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C2' editable dataAlign="center" >  </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='btnlocal' dataAlign="center" editable={false} width="30" dataFormat={this._cellButtonbtnlocal.bind(this)} columnClassName='c_btn'></TableHeaderColumn>


                        <TableHeaderColumn row='0' colSpan='2' headerAlign='center' className='colbuttomhidden' width='100' >หน่วยนับ</TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='C3' editable dataAlign="center" ></TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='btnunit' dataAlign="center" editable={false} width="30" dataFormat={this._cellButtonbtnunit.bind(this)} columnClassName='c_btn'></TableHeaderColumn>

                        <TableHeaderColumn row='0' rowSpan='2' dataField='C4' width='100' dataAlign='center' editable={{ type: 'select', options: { values: jobTypes } }}
                        > การใช้งาน </TableHeaderColumn>
                        <TableHeaderColumn dataField='C1_insert' editable width='100' hidden ></TableHeaderColumn>
                        <TableHeaderColumn dataField='C2_insert' editable width='100' hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='C3_insert' editable width='100' hidden ></TableHeaderColumn>
                    </BootstrapTable>
                    <br></br>
                    <div class="container-fluid">
                        <div class='col-xs-12 col-sm-6 col-md-6 col-lg-4' >
                            <div class="row">
                                <div class="container-fluid">
                                    <div class="form-group">
                                        <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span class="input-group-addon"> คลังเริ่มต้น : </span>
                                            <input id="defaultlibrary" name="defaultlibrary" type="text" class="form-control" tabIndex="4" ref="defaultlibrary"
                                                onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)}
                                            />
                                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "defaultlibrary")}>
                                                <i class="fas fa-list"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span class="input-group-addon"> ตำแหน่งรับเริ่มต้่น : </span>
                                            <input id="getstartedpendleton" name="getstartedpendleton" type="text" class="form-control" tabIndex="5" ref='getstartedpendleton'
                                                onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "getstartedpendleton")}>
                                                <i class="fas fa-list"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span class="input-group-addon"> หน่วยรับเริ่มต้น : </span>
                                            <input id="unitsdefaultreceiving" name="unitsdefaultreceiving" type="text" class="form-control " tabIndex="6" ref='unitsdefaultreceiving'
                                                onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                            <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "unitsdefaultreceiving")}> <i class="fas fa-list"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='col-xs-12 col-sm-6 col-md-6 col-lg-4' >
                            <div class="form-group">
                                <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <span class="input-group-addon"> คลังจ่ายเริ่มต้น : </span>
                                    <input id="defaularchives" name="defaularchives" type="text" class="    form-control" tabIndex="7" ref="defaularchives"
                                        onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                    <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "defaularchives")}> <i class="fas fa-list"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <span class="input-group-addon"> ตำแหน่งจ่ายเริ่มต้น : </span>
                                    <input id="defaulpayposition" name="defaulpayposition" type="text" class=" form-control " tabIndex="8" ref="defaulpayposition"
                                        onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                    <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "defaulpayposition")}> <i class="fas fa-list"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <span class="input-group-addon"> หน่วยจ่ายเริ่มต้น : </span>
                                    <input id="unitdefaulpay" name="unitdefaulpay" type="text" class="form-control" tabIndex="9" ref='unitdefaulpay'
                                        onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                    <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "unitdefaulpay")}> <i class="fas fa-list"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div id="load"></div>
                    </div>
                </div>
            </div>
        )
    }
}
